import * as React from 'react'

import { Loader2Icon } from 'lucide-react'

import { cn } from '@/lib/utils'

import { Button } from '@/components/ui/button'

type IconPosition = 'left' | 'right' | 'only'

interface SmartButtonProps extends React.ComponentProps<typeof Button> {
  loading?: boolean
  loadingText?: string
  loadingIcon?: string
  icon?: React.ReactNode
  iconPosition?: IconPosition
}

export const SmartButton = React.forwardRef<HTMLButtonElement, SmartButtonProps>(
  ({ children, loading, loadingText, loadingIcon, icon, iconPosition = 'left', className, ...props }, ref) => {
    const content = () => {
      if (loading) {
        return (
          <>
            {loadingIcon || <Loader2Icon className='h-4 w-4 animate-spin' />}
            {loadingText}
          </>
        )
      }

      if (iconPosition === 'only' && icon) {
        return icon
      }

      return (
        <>
          {icon && iconPosition === 'left' && icon}
          {children}
          {icon && iconPosition === 'right' && icon}
        </>
      )
    }

    return (
      <Button
        ref={ref}
        className={cn(className, loading ? 'cursor-not-allowed opacity-70' : '', 'cursor-pointer')}
        disabled={loading || props.disabled}
        {...props}
      >
        {content()}
      </Button>
    )
  }
)

SmartButton.displayName = 'SmartButton'
